<!-- Состояние загрузки и подготовки PDF-превью ЭДО-документа. -->
<template>
  <div class="pdf-loading-state" role="status" aria-live="polite">
    <div class="pdf-loading-state__document" aria-hidden="true">
      <span class="pdf-loading-state__fold"></span>
      <span class="pdf-loading-state__line pdf-loading-state__line--title"></span>
      <span class="pdf-loading-state__line"></span>
      <span class="pdf-loading-state__line pdf-loading-state__line--short"></span>
      <span class="pdf-loading-state__line"></span>
      <span class="pdf-loading-state__line pdf-loading-state__line--medium"></span>
    </div>

    <div class="pdf-loading-state__content">
      <span class="pdf-loading-state__spinner" aria-hidden="true"></span>
      <div>
        <p class="pdf-loading-state__title">Загружаем PDF</p>
        <p class="pdf-loading-state__text">Получаем файл и готовим предпросмотр</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EdoPdfLoadingState",
};
</script>

<style scoped>
.pdf-loading-state {
  display: flex;
  min-height: min(560px, calc(100vh - 210px));
  align-items: center;
  justify-content: center;
  gap: 28px;
  padding: 48px 24px;
  background: linear-gradient(145deg, #f8fafc 0%, #f0fdf9 100%);
}

.pdf-loading-state__document {
  position: relative;
  display: flex;
  width: 132px;
  height: 174px;
  flex-direction: column;
  gap: 13px;
  padding: 42px 20px 20px;
  border: 1px solid #d1fae5;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(15, 118, 110, 0.12);
  animation: document-pulse 1.8s ease-in-out infinite;
}

.pdf-loading-state__fold {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 34px;
  height: 34px;
  border-bottom: 1px solid #d1fae5;
  border-left: 1px solid #d1fae5;
  border-radius: 0 10px 0 8px;
  background: #ecfdf5;
}

.pdf-loading-state__line {
  width: 100%;
  height: 7px;
  border-radius: 999px;
  background: #d1fae5;
}

.pdf-loading-state__line--title {
  width: 62%;
  height: 9px;
  background: #6ee7b7;
}

.pdf-loading-state__line--short {
  width: 70%;
}

.pdf-loading-state__line--medium {
  width: 84%;
}

.pdf-loading-state__content {
  display: flex;
  align-items: center;
  gap: 14px;
}

.pdf-loading-state__spinner {
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border: 3px solid #a7f3d0;
  border-top-color: var(--color-green);
  border-radius: 50%;
  animation: pdf-loading-spin 0.8s linear infinite;
}

.pdf-loading-state__title,
.pdf-loading-state__text {
  margin: 0;
}

.pdf-loading-state__title {
  color: #111827;
  font-size: 16px;
  font-weight: 600;
}

.pdf-loading-state__text {
  margin-top: 4px;
  color: #6b7280;
  font-size: 13px;
}

@keyframes pdf-loading-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes document-pulse {
  50% {
    transform: translateY(-3px);
    box-shadow: 0 20px 42px rgba(15, 118, 110, 0.16);
  }
}

@media (max-width: 560px) {
  .pdf-loading-state {
    min-height: 420px;
    flex-direction: column;
    gap: 24px;
  }

  .pdf-loading-state__content {
    align-items: flex-start;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pdf-loading-state__document,
  .pdf-loading-state__spinner {
    animation: none;
  }
}
</style>
